module.exports = __webpack_public_path__ + "img/delivery-placeholder.46c0b43b.svg";